import React, { useState, useEffect } from "react";
import { authApi } from "../utils/api";

const LoginPage = ({ onLoginSuccess }) => {
  const [isLoginMode, setIsLoginMode] = useState(true);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const savedUser = localStorage.getItem("rememberedUsername");
    if (savedUser) {
      setUsername(savedUser);
      setRemember(true);
    }
  }, []);

  // 登录（使用 authApi）
  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const { ok, data } = await authApi.login(username, password);
      if (ok && data?.access_token) {
        if (remember) {
          localStorage.setItem("rememberedUsername", username);
        } else {
          localStorage.removeItem("rememberedUsername");
        }
        localStorage.setItem("isLoggedIn", "true");
        onLoginSuccess();
      } else {
        setError(data?.detail || "用户名或密码错误");
      }
    } catch (err) {
      console.error("登录错误:", err);
      setError("网络错误，请确保后端服务正在运行");
    } finally {
      setIsLoading(false);
    }
  };

  // 真实注册
  const handleRegister = async (e) => {
    e.preventDefault();
    setError("");

    // 简单验证
    if (password !== confirmPassword) {
      setError("两次密码不一致");
      return;
    }
    if (password.length < 6) {
      setError("密码长度至少6位");
      return;
    }
    if (username.length < 3 || username.length > 20) {
      setError("用户名长度需为3-20位");
      return;
    }

    try {
      const { ok, data } = await authApi.register(username, password);
      if (ok) {
        // 注册成功，自动切换到登录
        setError("");
        setIsLoginMode(true);
        setConfirmPassword("");
      } else {
        setError(data?.detail || "注册失败");
      }
    } catch (err) {
      console.error("注册错误:", err);
      setError("网络错误，请确保后端服务正在运行");
    }
  };

  return (
    <div style={container}>
      <div style={loginCard}>
        {/* 🔥 标题已修改为 Frenchclick */}
        <h2 style={title}>Frenchclick</h2>
        <p style={subTitle}>
          {isLoginMode ? "欢迎回来，请登录" : "创建新账号"}
        </p>

        {/* 切换登录/注册的标签 */}
        <div style={tabHeader}>
          <button 
            style={isLoginMode ? {...tabBtn, ...tabBtnActive} : tabBtn}
            onClick={() => {setIsLoginMode(true); setError("");}}
          >
            登录
          </button>
          <button 
            style={!isLoginMode ? {...tabBtn, ...tabBtnActive} : tabBtn}
            onClick={() => {setIsLoginMode(false); setError("");}}
          >
            注册
          </button>
        </div>

        <form onSubmit={isLoginMode ? handleLogin : handleRegister} style={form}>
          <div style={inputGroup}>
            <label style={label}>用户名</label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              style={input}
              placeholder="请输入用户名"
              autoComplete="username"
              required
            />
          </div>

          <div style={inputGroup}>
            <label style={label}>密码</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={input}
              placeholder="请输入密码"
              autoComplete={isLoginMode ? "current-password" : "new-password"}
              required
            />
          </div>

          {/* 注册模式：显示确认密码 */}
          {!isLoginMode && (
            <div style={inputGroup}>
              <label style={label}>确认密码</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                style={input}
                placeholder="请再次输入密码"
                required
              />
            </div>
          )}

          {/* 登录模式：显示记住账号 */}
          {isLoginMode && (
            <div style={rememberWrap}>
              <input
                type="checkbox"
                checked={remember}
                onChange={() => setRemember(!remember)}
                id="remember"
              />
              <label htmlFor="remember" style={rememberLabel}>
                记住账号
              </label>
            </div>
          )}

          {error && <p style={errorText}>{error}</p>}

          <button type="submit" style={loginBtn}>
            {isLoginMode ? "登录" : "注册"}
          </button>
        </form>
      </div>
    </div>
  );
};

// 样式
const container = {
  width: "100vw",
  height: "100vh",
  backgroundImage: `url('/1.jpg')`,
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: 0,
};

const loginCard = {
  background: "rgba(255, 255, 255, 0.25)",
  backdropFilter: "blur(10px)",
  WebkitBackdropFilter: "blur(10px)",
  border: "1px solid rgba(255,255,255,0.3)",
  padding: "40px",
  borderRadius: "16px",
  width: "100%",
  maxWidth: "420px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
};

const title = {
  textAlign: "center",
  fontSize: "24px",
  fontWeight: 700,
  color: "#fff",
  marginBottom: "6px",
};

const subTitle = {
  textAlign: "center",
  color: "rgba(255,255,255,0.8)",
  marginBottom: "20px",
  fontSize: "14px",
};

const tabHeader = {
  display: "flex",
  marginBottom: "24px",
  borderBottom: "1px solid rgba(255,255,255,0.2)",
};

const tabBtn = {
  flex: 1,
  padding: "10px",
  border: "none",
  borderBottomWidth: "2px",
  borderBottomStyle: "solid",
  borderBottomColor: "transparent",
  background: "none",
  fontSize: "16px",
  cursor: "pointer",
  color: "rgba(255,255,255,0.6)",
  transition: "all 0.3s",
};

const tabBtnActive = {
  color: "#fff",
  borderBottomColor: "#fff",
};

const form = {
  display: "flex",
  flexDirection: "column",
  gap: "18px",
};

const inputGroup = {
  display: "flex",
  flexDirection: "column",
  gap: "6px",
};

const label = {
  fontSize: "14px",
  color: "#fff",
  fontWeight: 500,
};

const input = {
  padding: "12px 16px",
  borderRadius: "10px",
  border: "none",
  outline: "none",
  background: "rgba(255,255,255,0.9)",
  fontSize: "15px",
};

const rememberWrap = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
  marginTop: "4px",
};

const rememberLabel = {
  fontSize: "13px",
  color: "#fff",
};

const loginBtn = {
  background: "#fff",
  color: "#667eea",
  border: "none",
  padding: "14px",
  borderRadius: "10px",
  fontSize: "16px",
  fontWeight: 700,
  cursor: "pointer",
  marginTop: "8px",
  transition: "transform 0.2s",
};

const errorText = {
  color: "#ff6b6b",
  fontSize: "13px",
  textAlign: "center",
  margin: 0,
};

export default LoginPage;